import { createContext } from 'react';

export const FieldActionVisibilityContext = createContext(false);
